import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const AVNetwork: Site = {
  id: 'avnetwork',
  logo: 'svg/avnetwork.svg',
  label: 'AV Network',
  analyticsName: 'avnetwork',
  hostname: 'avnetwork.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
